import { createSelector, Selector } from 'reselect'
import { IStatisticsState } from './models'
import { IStatisticsOwnState } from '../model'
import { BRANCH_KEY } from '../branch'

export const branch: Selector<IStatisticsOwnState, IStatisticsState> = (state) => state[BRANCH_KEY]?.statistics

export const permissions = createSelector(branch, (branch) => branch?.permissions)
